export function parseCondition(value: string): string {
  const conditionMap: { [key: string]: string } = {
    '未使用': 'new',
    '未使用に近い': 'like-new',
    '目立った傷や汚れなし': 'good',
    'やや傷や汚れあり': 'fair',
    '傷や汚れあり': 'poor',
    '全体的に状態が悪い': 'bad'
  };
  return conditionMap[value] || '';
}

export function parseYesNo(value: string): boolean {
  return value === 'はい';
}

export function parsePrice(value: string): number {
  return parseInt(value) || 0;
}